import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  Divider
} from '@mui/material';
import { Helmet } from 'react-helmet';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link as RouterLink } from 'react-router-dom';

const AdminConfig: React.FC = () => {
  const [config, setConfig] = useState({
    siteName: 'ET-Business Directory',
    siteDescription: 'Find verified Ethiopian businesses across major cities',
    contactEmail: 'info@et-business.com',
    contactPhone: '+251 123 456 789',
    address: 'Bole Road, Addis Ababa, Ethiopia',
    enableRegistration: true,
    requireVerification: true,
    maxListingsPerUser: '5',
    googleAnalyticsId: '',
    facebookPixelId: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Implement config saving
    console.log('Saving config:', config);
  };

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default', py: 4 }}>
      <Helmet>
        <title>Admin Configuration | ET-Business Directory</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Container maxWidth="lg">
        <Box sx={{ mb: 4 }}>
          <Button
            component={RouterLink}
            to="/admin/dashboard"
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Back to Dashboard
          </Button>
          <Typography variant="h4" component="h1">
            Site Configuration
          </Typography>
        </Box>

        <Paper sx={{ p: 3 }}>
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  General Settings
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Site Name"
                  name="siteName"
                  value={config.siteName}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Site Description"
                  name="siteDescription"
                  value={config.siteDescription}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                  Contact Information
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Contact Email"
                  name="contactEmail"
                  value={config.contactEmail}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Contact Phone"
                  name="contactPhone"
                  value={config.contactPhone}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={config.address}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                  Business Listing Settings
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={config.enableRegistration}
                      onChange={handleChange}
                      name="enableRegistration"
                    />
                  }
                  label="Enable Business Registration"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={config.requireVerification}
                      onChange={handleChange}
                      name="requireVerification"
                    />
                  }
                  label="Require Business Verification"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Max Listings Per User"
                  name="maxListingsPerUser"
                  type="number"
                  value={config.maxListingsPerUser}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
                  Analytics Settings
                </Typography>
                <Divider sx={{ mb: 2 }} />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Google Analytics ID"
                  name="googleAnalyticsId"
                  value={config.googleAnalyticsId}
                  onChange={handleChange}
                  placeholder="UA-XXXXXXXXX-X"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Facebook Pixel ID"
                  name="facebookPixelId"
                  value={config.facebookPixelId}
                  onChange={handleChange}
                  placeholder="XXXXXXXXXXXXXXXXXX"
                />
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Save Changes
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default AdminConfig; 